var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrashRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.75 3.75C1.75 3.33579 2.08579 3 2.5 3H13.5C13.9142 3 14.25 3.33579 14.25 3.75C14.25 4.16421 13.9142 4.5 13.5 4.5H2.5C2.08579 4.5 1.75 4.16421 1.75 3.75Z",
    fill: "#EC5B5E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 5.75C6.91421 5.75 7.25 6.08579 7.25 6.5V10.5C7.25 10.9142 6.91421 11.25 6.5 11.25C6.08579 11.25 5.75 10.9142 5.75 10.5V6.5C5.75 6.08579 6.08579 5.75 6.5 5.75Z",
    fill: "#EC5B5E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 5.75C9.91421 5.75 10.25 6.08579 10.25 6.5V10.5C10.25 10.9142 9.91421 11.25 9.5 11.25C9.08579 11.25 8.75 10.9142 8.75 10.5V6.5C8.75 6.08579 9.08579 5.75 9.5 5.75Z",
    fill: "#EC5B5E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 3C3.91421 3 4.25 3.33579 4.25 3.75V12.75H11.75V3.75C11.75 3.33579 12.0858 3 12.5 3C12.9142 3 13.25 3.33579 13.25 3.75V13C13.25 13.3315 13.1183 13.6495 12.8839 13.8839C12.6495 14.1183 12.3315 14.25 12 14.25H4C3.66848 14.25 3.35054 14.1183 3.11612 13.8839C2.8817 13.6495 2.75 13.3315 2.75 13V3.75C2.75 3.33579 3.08579 3 3.5 3Z",
    fill: "#EC5B5E"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26256 1.01256C5.59075 0.684374 6.03587 0.5 6.5 0.5H9.5C9.96413 0.5 10.4092 0.684374 10.7374 1.01256C11.0656 1.34075 11.25 1.78587 11.25 2.25V3.75C11.25 4.16421 10.9142 4.5 10.5 4.5C10.0858 4.5 9.75 4.16421 9.75 3.75V2.25C9.75 2.1837 9.72366 2.12011 9.67678 2.07322C9.62989 2.02634 9.5663 2 9.5 2H6.5C6.4337 2 6.37011 2.02634 6.32322 2.07322C6.27634 2.12011 6.25 2.1837 6.25 2.25V3.75C6.25 4.16421 5.91421 4.5 5.5 4.5C5.08579 4.5 4.75 4.16421 4.75 3.75V2.25C4.75 1.78587 4.93437 1.34075 5.26256 1.01256Z",
    fill: "#EC5B5E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashRed);
export default __webpack_public_path__ + "static/media/trash_red.cf33e42a.svg";
export { ForwardRef as ReactComponent };